<template>
    <div class="task-management parent-frame">
        <div class="task-management-wrap">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
export default {
    name: 'taskManagement',
    data () {
        return {

        }
    }
}
</script>
<style lang="scss" scoped>
    .task-management{
        position: relative;
        .task-management-wrap{
            padding: 40px;
        }
    }
    @media screen and (max-width: 1280px){
        .task-management{
            .task-management-wrap{
                padding: 30px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/TaskManagementPages/TaskManagement.vue